
angular.module('cesium.graph.plugin', [
    // Services
    'cesium.graph.services',
    // Controllers
    'cesium.graph.common.controllers',
    'cesium.graph.blockchain.controllers',
    'cesium.graph.network.controllers',
    'cesium.graph.currency.controllers',
    'cesium.graph.account.controllers',
    'cesium.graph.docstats.controllers',
    'cesium.graph.synchro.controllers'
  ])
;
